
import {Component, Vue, Watch} from 'vue-property-decorator';
import baseUrl, {imageUrl} from "../../constants";
import ckeditor4 from "@/components/CkeditorComponent.vue";
import {materialApi} from '@/api/material';
import {materialTypeList} from "@/js/checkType";
import SelectMechanism from "@/components/SelectMechanism.vue";
import {dictInstrumentApi, mechanismNameApi} from "@/api/organization";
@Component({
  name: 'measuringDetail',
  components: {
   ckeditor4,SelectMechanism
  }
})
export default class Home extends Vue {

  title = "标准物质信息";
  type = "";//Look 查看  Add 添加 Edit 编辑 Examine 审核
  mode = "";//This_Unit 本单位
  id = 0;   //标准物质的id
  typeList = materialTypeList
  form = {
    mainDevOrgId: '',
    mainDevOrgNameId: '',
    mainDevOrgName: '',
    useStatus: '在产',
    type: '',
    form: '', // 物质形态
    level: '',
    certNumber: '',
    number: '',
    dictInstrumentId: '',
    dictInstrumentNameId: '',
    name: '',
    materialData: [{materialNumber: '', data: '[{"part":"","value":"","deviation":"","unit":""}]', remark: '', materialName: ''}],
    feature: '',
    issuingAuthority: '',
    issuingAuthorityNameId: '',
    issuedDate: '',
    // attachFile: '',
    fileList: [] as any,
    orgList: [{devOrgName: ''}],
    ruleList: [{ruleId: "", ruleNumber: "", ruleName: ""}] as any,
  }
  rules = {
    mainDevOrgNameId: [{required: true, message: '请选择标准物质主要研制机构', trigger: 'change'}],
    type: [{required: true, message: '请选择标准物质类型', trigger: 'change'}],
    // form: [{required: true, message: '请选择标准物质形态', trigger: 'change'}],
    level: [{required: true, message: '请选择等级', trigger: 'blur'}],
    certNumber: [{required: true, message: '请输入标准物质证书编号', trigger: 'blur'}],
    number: [{required: true, message: '请输入标准物质编号', trigger: 'blur'}],
    dictInstrumentNameId: [{required: true, message: '请选择标准物质名称', trigger: 'change'}],
    feature: [{required: true, message: '请输入特征形态', trigger: 'blur'}],
    issuedDate: [{required: true, message: '请选择发证日期', trigger: 'blur'}],
    issuingAuthorityNameId: [{required: true, message: '请选择发证机关', trigger: 'change'}],
    fileList: [{required: true, message: '请上传附件', trigger: 'change'}],
    // accuracyLevel: [{required: true, message: '请填写特性量、特性值及不确定度', type: 'array'}],
    devOrgName: [{required: true, message: '请输入标准物质研制机构', trigger: 'blur'}],
    ruleId: [{required: true, message: '请选择标准物质规范', trigger: 'change'}],
    // orgList: [{required: true, message: '请选择标准物质研制机构', trigger: 'change'}],
    ruleList: [{required: true, message: '请选择标准物质规范', trigger: 'change'}],
  }
  baseUrl = baseUrl
  headers = {Authorization: ""}
  private closePage: any;
  dialog = {
    visible: false,
    list: [] as any,
    rules: {
      materialNumber: [
          {required: true, validator: this.autoMaterialNoRepeat, trigger: 'blur'}
      ],
      // unit: [{required: true, message: '请输入单位', trigger: 'blur'}],
      // part: [{required: true, message: '请输入成分', trigger: 'blur'}],
      // value: [{required: true, message: '请输入标准值', trigger: 'blur'}],
      // deviation: [{required: true, message: '请输入不确定度', trigger: 'blur'}]
    }
  }
  dictInstrList = [];
  orgList = [];
  review = {
    failDialog: false,
    failText: '',
  }

  created() {
    this.type = this.$route.params.type;
    this.mode = this.$route.params.mode;
    this.id = Number(this.$route.params.id);
    this.listDictInstr();
    this.listOrg();
    if (this.id !== 0) {
      this.getDetail();
    }else{
      const userData = this.$store.state.AuthedUser;
      this.form.mainDevOrgId = userData.mechanismNames[0].mechanismId;
      this.form.mainDevOrgNameId =userData.mechanismNames[0].id;
      this.form.mainDevOrgName = userData.mechanismNames[0].name;
    }
  }

  addChildData(arr: Array<any>){
    arr.push(this.initData());
  }


  autoMaterialNoRepeat(rule: any, value: string, callback: any){
    if (value === '') {
      callback(new Error('请输入标准物质编号'));
      return;
    }
    const a = this.dialog.list.filter((a: any) => a.materialNumber == value);
    if(a.length > 1){
      callback(new Error('标准物质编号重复'));
      return;
    }
    materialApi.autoMaterialNoRepeat(value, this.id).then((r: any) => {
      if(r.data.result === 0){
        if(r.data.data){
          callback(new Error('标准物质编号重复'));
        }else{
          callback();
        }
      }
    });
  }

  delChildData(arr: Array<any>, index: number){
    arr.splice(index, 1);
  }

  toTableData(){
    const materialData = this.cloneData(this.form.materialData);
    materialData.forEach((d: any) => {
      d.data = JSON.parse(d.data) || [];
    });
    return materialData;
  }

  changeDictInstr(e: any){
    const dictInstr = this.dictInstrList.filter((c: any) => c.instrumentNameId == e)[0] as any;
    this.form.dictInstrumentId = dictInstr.id;
    this.form.name = dictInstr.name;
    if(dictInstr.rules) {
      const arr = dictInstr.rules.split("】/");
      const arr2 = [] as any;
      for (let i = 0; i < arr.length; i++) {
        let thisArr = arr[i];
        if (i != arr.length - 1 && arr.length > 1) {
          thisArr += "】";
        }
        const arr3 = thisArr.split("【");
        let number = "";
        let name = "";
        if (arr3.length > 1) {
          number = arr3[0];
          const reg = new RegExp(/(?<=【).*?(?=】)/, 'g');
          name = thisArr.match(reg)[0];
        } else {
          const arr4 = thisArr.split(",");
          if (arr4.length > 1) {
            number = arr4[0];
            name = arr4[1];
          }
        }
        arr2.push({ruleNumber: number, ruleName: name});
      }
      this.form.ruleList = arr2;
    }else{
      this.form.ruleList = [];
    }
  }

  getDetail() {
    materialApi.get(this.id).then((r: any) => {
      if (r.data.result === 0) {
        const rData = r.data.data;
        if(rData.materialData == null || rData.materialData.length === 0){
          rData.materialData = [{materialName: '', materialNumber: '', data: '[{"part":"","value":"","deviation":"","unit":""}]', remark: ''}];
        }
        Object.assign(this.form, rData);
        if (rData.attachFile) {
          const arr = rData.attachFile.split(',');
          for (let i = 0; i < arr.length; i++) {
            this.form.fileList.push({name: "标准物质附件" + (i + 1), url: imageUrl + arr[i]})
          }
        }

      }
    });
  }

  listOrg(){
    mechanismNameApi.list({ownerId: '502cd9916912a4d66b4d4c0da9c6c518'}).then((r: any) => {
      if(r.data.result === 0){
        this.orgList = r.data.data;
      }
    });
  }

  listDictInstr(){
    dictInstrumentApi.listDictInstrByParentId(3002).then((r: any) => {
      if(r.data.result === 0){
        this.dictInstrList = r.data.data;
      }
    });
  }

  closeFail() {
    this.review.failText = "";
    this.review.failDialog = false;
  }

  edit(status: number, callback: any) {
    const attachFile = this.form.fileList.map((e: any) => {
      return e.url.replace(imageUrl, "")
    });
    let form = this.$refs.form as HTMLFormElement;
    form.validate((valid: any) => {
      if (valid) {
        const formData = this.cloneData(this.form);
        if(formData.materialData && formData.materialData.length === 1 && formData.materialData[0].materialNumber == ''){
          formData.materialData = [];
        }
        materialApi.edit({
          ...formData,
          status: status,
          attachFile: attachFile.join(',')
        }).then((r: any) => {
          if (r.data.result === 0) {
            if (callback) {
              callback();
            } else {
              this.$message.success("操作成功，1秒后返回上一页！");
              setTimeout(() => {
                this.closePage()
              }, 1000);
            }
          }
        });
      }
    });

  }

  saveOrSubmit(status: number) {
    this.edit(status, null);
  }

  passOrNot(status: number) {
    if (status == 3) {
      //不通过，必须有原因
      if (this.review.failText == "") {
        this.$message.error("请填写不通过原因！");
        return
      }
    }
    this.edit(status, () => {
      materialApi.passOrNot({id: this.id, status: status, reason: this.review.failText}).then((r: any) => {
        if (r.data.result === 0) {
          this.$message.success("审核成功，1秒后返回上一页！");
          this.closeFail();
          setTimeout(() => {
            this.closePage()
          }, 1000);
        }
      });
    });
  }

  arraySpanMethod({rowIndex, columnIndex}: any) {
    if (rowIndex === 0 && columnIndex === 7) {
      return {
        rowspan: this.form.materialData.length,
        colspan: 1
      };
    }
  }

  delData(index: number) {
    this.dialog.list.splice(index, 1);
  }

  addData() {
    this.dialog.list.push({materialName: '', materialNumber: '' ,data:[this.initData()], remark: ''});
  }

  initData() {
    return {'part': '', 'value': '', 'deviation': '', 'unit': ''};
  }

  cloneData(data: any) {
    return JSON.parse(JSON.stringify(data));
  }

  submitDialog() {
    let dialogForm = this.$refs.dialogForm as HTMLFormElement;
    dialogForm.validate((valid: any) => {
      if (valid) {
        const dataList = this.cloneData(this.dialog.list);
        dataList.forEach((d: any) => {
          d.data = JSON.stringify(d.data);
        });
        console.log(dataList);
        this.form.materialData = dataList;
        this.closeDialog();
      }
    });
  }

  closeDialog() {
    this.dialog.visible = false;
    this.dialog.list = [];
  }

  openDialog() {
    this.dialog.visible = true;
    let data = this.cloneData(this.form.materialData);
    data = data.map((md: any) => {
      md.data = JSON.parse(md.data) || [];
      return md;
    })
    this.dialog.list = data;
  }

  getTitle() {
    let headerTitle = "";
    if (this.type === 'Look') {
      headerTitle = "查看";
    } else if (this.type === 'Add' || this.type === 'Edit') {
      headerTitle = "添加/编辑";
    } else if (this.type === 'Examine') {
      headerTitle = "待审核";
    }
    headerTitle += '标准物质'
    return headerTitle;
  }

  hasBtn(mode: string) {
    if (mode === 'save') {
      return this.type === 'Add' || this.type === 'Edit';
    } else if (mode === 'submit') {
      return this.type === 'Add' || this.type === 'Edit';
    } else if (mode === 'past') {
      return this.type === 'Examine';
    }
  }

  addOrg() {
    this.form.orgList.push({devOrgName: ''});
  }

  delOrg(rowIndex: any) {
    this.form.orgList.splice(rowIndex, 1);
  }

  changeIssuingAuthority(e: any) {
    const org = this.orgList.filter((c: any) => c.id == e)[0] as any;
    this.form.issuingAuthority = org.name;
  }

  changeOrg(e: any) {
    const {mechanismName, mechanismNameId, mechanismId} = e;
    this.form.mainDevOrgId = mechanismId;
    this.form.mainDevOrgNameId = mechanismNameId;
    this.form.mainDevOrgName = mechanismName;
  }



  move(mode: string, rowIndex: number) {
    if (mode === 'top') {
      this.moveUp(this.form.orgList, rowIndex);
    } else if (mode === 'down') {
      this.moveDown(this.form.orgList, rowIndex);
    }
  }


  moveUp(list: Array<any>, index: number) {
    if (index != 0) {
      list[index] = list.splice(index - 1, 1, list[index])[0];
    } else {
      list.push(list.shift());
    }
  }

  moveDown(list: Array<any>, index: number) {
    if (index != list.length - 1) {
      list[index] = list.splice(index + 1, 1, list[index])[0];
    } else {
      list.unshift(list.splice(index, 1)[0]);
    }
  }

  handleAttachFileSuccess(res: any, file: any) {
    if (res.result === 0) {
      const rData = res.data;
      this.form.fileList.push({name: "标准物质附件" + (this.form.fileList.length + 1), url: imageUrl + rData});
    }
  }

  handleAttachFileRemove(file: any) {
    const index = this.form.fileList.findIndex((e: any) => e.url === file.url);
    if (index > -1) {
      this.form.fileList.splice(index, 1);
    }
  }

  beforeAttachFileUpload(file: any) {
    const isJPG = file.type === 'image/jpeg';
    const isPNG = file.type === 'image/png';
    const isPDF = file.type === 'application/pdf';

    if (!isJPG && !isPNG && !isPDF) {
      this.$message.error('上传图片只能是 JPG / PNG / PDF格式!');
    }
    return (isJPG || isPNG || isPDF);
  }

  handleAttachFilePreview(file: any) {
    console.log(file);
    window.open(baseUrl + "/file/download?file=" + file.url.replace(imageUrl, "") + "&name=" + file.name, '_blank');
  }
}
